import { addMethod, object, ref, string } from "yup"
import { MAX_EMAIL_LENGTH } from "./customer"
import { buildSchema } from "./util/build-schema"

const minPasswordLength = 12
const myEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

addMethod(string, "email", function validateEmail(message?: string) {
  return this.matches(myEmailRegex, {
    message: message ?? "yup.common.string.email",
    name: "email",
    excludeEmptyString: true,
  })
})

const schema = object({
  email: string().email().max(MAX_EMAIL_LENGTH).required(),
  password: string().min(minPasswordLength).required(),
  passwordConfirmation: string()
    .nullable()
    .oneOf([ref("password"), null], "yup.user.passwordConfirmation.mustMatch"),
  username: string()
    .required()
    .matches(/^[a-zA-Z0-9]+$/, {
      message: "Must contain only letters and numbers",
      excludeEmptyString: true,
    }),
})

export const userSchema = buildSchema("User", schema)
